function Hero() {
  return (
    <section
      id="home"
      className="relative min-h-screen bg-gradient-to-br from-black via-gray-900 to-black text-white flex items-center pt-20 px-4 overflow-hidden"
    >
      {/* Animated Background + Custom Image */}
      <div className="absolute inset-0">
        {/* Animated Gradient Orbs */}
        <div className="absolute w-96 h-96 bg-green-500 rounded-full blur-3xl opacity-20 -top-48 -left-48 animate-pulse"></div>
        <div
          className="absolute w-96 h-96 bg-emerald-500 rounded-full blur-3xl opacity-20 -bottom-48 -right-48 animate-pulse"
          style={{ animationDelay: "1s" }}
        ></div>

        {/* Mobile full-body image */}
        <img
          src="smallbg.png" // Place your image in public/fullbody.png or update the path
          alt="Full Body"
          className="mobile-fullbody-img absolute left-0 right-0 bottom-0 block sm:hidden"
          style={{ zIndex: 2 }}
        />
        <style>{`
          @media (max-width: 640px) {
            .mobile-fullbody-img {
              display: block;                                          
              margin: 0 auto;
              width: 80vw;
              max-width: 320px;
              height: auto;
              position: absolute;
              left: 0;
              right: 0;
              bottom: 0;
            }
          }
        `}</style>

        {/* Desktop background image */}
        <div
          className="absolute inset-0 w-full h-full bg-center bg-cover hidden sm:block"
          style={{
            backgroundImage: `url('bg.png')`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            minHeight: "100vh",
          }}
        ></div>
      </div>

      {/* Content goes here */}
      <div className="relative z-10 max-w-4xl mx-auto">
        {/* Add your hero content here */}
      </div>
    </section>
  );
}

export default Hero;
